export namespace DocumentFieldConstants {
  export const VEHICLE_MILEAGE: string = 'Vehicle Mileage';
  export const VEHICLE_INSPECTION_DATE: string = 'Vehicle Inspection Date';
  export const DOCUMENT_FIELD_NAME_SEX = 'Sex';
  export const DOCUMENT_FIELD_NAME_CITY = 'City';
}
